import React from "react";
import { connect } from "react-redux";
import { I18n } from "@aws-amplify/core";
import { withStyles } from "@material-ui/styles";
import {
  get,
  filter,
  size,
  forEach,
  uniqBy,
  includes,
  toString,
  toLower,
} from "lodash";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Tabs from "@material-ui/core/Tabs";
import Dialog from "@material-ui/core/Dialog";
import InputAdornment from "@material-ui/core/InputAdornment";
import CircularProgress from "@material-ui/core/CircularProgress";

import CloseIcon from "../Common/CloseIcon";
import CustomTab from "../Common/CustomTab";
import CustomInput from "../Common/CustomInput";
import CustomButton from "../Common/CustomButton";
import ProfilesResults from "./ProfilesResults";
import { fetchPost } from "../../api/fetch";
import images from "../../assets/img/images";
import colors from "../../assets/style/colors";

const styles = {
  dialogPaper: {
    width: "calc(100vw - 140px)",
    maxWidth: "1400px",
    height: "calc(100vh - 100px)",
    maxHeight: "900px",
    padding: "12px 0px 0px",
  },
  closeIcon: {
    paddingRight: "12px",
    display: "flex",
    justifyContent: "flex-end",
  },
  tabBar: {
    zIndex: 1,
    height: "30px",
    paddingLeft: "24px",
    margin: "0px -24px 24px",
    borderBottom: `1px solid ${colors.veryLighPink}`,
  },
  tabs: {
    height: "30px",
    float: "left",
    minHeight: "30px",
  },
  inputAdornment: {
    backgroundColor: colors.white,
    cursor: "pointer",
  },
  resultsContainer: {
    height: "calc(100vh - 303px)",
    overflow: "auto",
    borderRadius: "4px",
  },
};

const GlobalSearch = (props) => {
  const { classes, language } = props;
  const [open, setOpen] = React.useState(false);
  const [searchValue, setSearchValue] = React.useState("");
  const [results, setResults] = React.useState({
    profiles: null,
    events: null,
  });
  const [isFetching, setIsFetching] = React.useState(false);
  const [activeTab, setActiveTab] = React.useState(0);

  const input = document.getElementById("search-input");

  React.useEffect(() => {
    // Set auto focus
    if (open && input) {
      input.focus();
    }

    if (window.getSelection().toString()) {
      setSearchValue(window.getSelection().toString());
    }
  }, [open, input]);

  const search = async () => {
    setIsFetching(true);
    try {
      let res = await fetchPost("profiles/search", {
        search_text: searchValue,
      });
      res = uniqBy(res, (item) => get(item, ["id"]));
      forEach(res, (item) => {
        // Profile photo
        item.photo = get(
          filter(
            get(item, ["images"]),
            (img) =>
              img.active &&
              (get(item, ["type", "id"]) !== 1 ||
                get(img, ["enrollment_status"]))
          ),
          [0, "url"]
        );
        // String Found & attribute
        let stringFound, attribute, attributeId;
        forEach(get(item, ["attributes"]), (attr) => {
          if (
            includes(
              toLower(toString(get(attr, ["value"]))),
              toLower(searchValue)
            )
          ) {
            stringFound = get(attr, ["value"]);
            attribute = get(attr, [`name_${language}`]);
            attributeId = get(attr, ["id"]);
          }
        });
        item.stringFound = stringFound;
        item.attribute = attribute;
        item.attributeId = attributeId;
      });
      setResults({
        profiles: res,
      });
    } catch (e) {
      console.log(e);
    }
    setIsFetching(false);
  };

  const cleanSearchedProfiles = () => {
    setSearchValue("");
    setResults();
  };

  return (
    <>
      <Box onClick={() => setOpen(true)}>{props.children}</Box>
      <Dialog open={open} classes={{ paper: classes.dialogPaper }}>
        <Grid container direction="column">
          <Grid item>
            <Grid container alignItems="center">
              <Grid item xs={2} />
              <Grid item xs></Grid>
              <Grid item xs={2} className={classes.closeIcon}>
                <CloseIcon closeFunction={() => setOpen(false)} />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs style={{ padding: "0px 24px 24px" }}>
            <Grid container direction="column">
              <Grid item>
                <Grid
                  container
                  alignItems="center"
                  wrap="nowrap"
                  style={{ marginTop: "-20px", maxWidth: "calc(100% - 40px)" }}
                >
                  <Grid item style={{ width: 300 }}>
                    <CustomInput
                      name="name"
                      id="search-input"
                      value={searchValue}
                      onChange={(e) => setSearchValue(e.target.value)}
                      startAdornment={
                        <img src={images.searchIcon} alt="search" />
                      }
                      endAdornment={
                        isFetching ? (
                          <InputAdornment
                            position="end"
                            classes={{ root: classes.inputAdornment }}
                          >
                            <CircularProgress size={14} />
                          </InputAdornment>
                        ) : searchValue ? (
                          <InputAdornment
                            position="end"
                            classes={{ root: classes.inputAdornment }}
                          >
                            <img
                              src={images.closeIcon}
                              alt="clean"
                              onClick={cleanSearchedProfiles}
                              width="12px"
                              height="12px"
                            />
                          </InputAdornment>
                        ) : null
                      }
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          search();
                        }
                      }}
                    />
                  </Grid>
                  <Grid item style={{ marginLeft: 15 }}>
                    <CustomButton
                      color="primary"
                      variant="contained"
                      onClick={search}
                    >
                      {I18n.get("dashboard_search")}
                    </CustomButton>
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                item
                className="text-87 bold-500"
                style={{ margin: "24px 0px 12px" }}
              >
                {`${results === undefined
                  ? "-"
                  : size(get(results, ["profiles"])) +
                  size(get(results, ["events"]))
                  } ${I18n.get("site_resultsFound")}`}
              </Grid>
              <Grid item className={classes.tabBar}>
                <Tabs
                  value={activeTab}
                  onChange={(e, v) => setActiveTab(v)}
                  indicatorColor="primary"
                  centered
                  className={classes.tabs}
                >
                  <CustomTab
                    height="30px"
                    label={`${I18n.get("topbar_profiles")} (${size(
                      get(results, ["profiles"])
                    )})`}
                    value={0}
                  />
                  <CustomTab
                    height="30px"
                    label={`${I18n.get("site_historyEvents")} (${size(
                      get(results, ["events"])
                    )})`}
                    value={1}
                    disabled
                  />
                </Tabs>
              </Grid>
              <Grid item className={classes.resultsContainer}>
                {activeTab === 0 && (
                  <ProfilesResults
                    profiles={get(results, ["profiles"])}
                    searchValue={searchValue}
                    language={language}
                    isFetching={isFetching}
                    onRedirect={() => setOpen(false)}
                  />
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Dialog>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    language: state.user.language,
  };
};

export default connect(mapStateToProps)(withStyles(styles)(GlobalSearch));
